import React, { useState, useEffect } from "react";
import Header from "./components/header";
import Footer from "./components/footer";
import Homepage from "./pages/Home/homepage";
import Resume from "./pages/Resume/resume";
import notes from "./pages/Home/ProfileNote";
import Projects from "./pages/Projects/Projects";
import { Routes, Route } from "react-router-dom";
// import Loader from "./Loader";
import Contact from "./pages/Contact/Contact";
import Applications from "./pages/Applications/Applications";


const App = () => {
  // const location = useLocation();
  // const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);

  // useEffect(() => {
  //   setLoading(true);
  //   const timeout = setTimeout(() => setLoading(false), 1000);
  //   return () => clearTimeout(timeout);
  // }, [location]);

  //use for right click button not clickable
  // useEffect(() => {
  //   const handleContextMenu = (e) => e.preventDefault();
  //   document.addEventListener("contextmenu", handleContextMenu);
  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //   };
  // }, []);


  // return loading ? (
  //   <Loader />
  // ) : (
  //   <>
  //     <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
  //     <Routes>
  //       <Route path="/" element={<Homepage notes={notes} />} />
  //       <Route path="/Homepage" element={<Homepage notes={notes} />} />
  //       <Route path="/Projects" element={<Projects showSidebar={showSidebar} />} />
  //       <Route path="/Resume" element={<Resume />} />
  //       <Route path="/Contact" element={<Contact/>} />

  //     </Routes>
  //     <Footer />
  //   </>
  // );



  // use for right click button not clickable
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  return (
    <>
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <Routes>
        <Route path="/" element={<Homepage notes={notes} />} />
        <Route path="/Homepage" element={<Homepage notes={notes} />} />
        <Route path="/Projects" element={<Projects showSidebar={showSidebar} />} />
        <Route path="/web-apps" element={<Applications />}/>

        <Route path="/Resume" element={<Resume />} />
        <Route path="/Contact" element={<Contact />} />

      </Routes>
      <Footer />
    </>
  );
};

export default App;
